import { Controller } from '@hotwired/stimulus';

export default class ChangeDistributorController extends Controller {
  static targets = ['select', 'submitButton', 'newAdvisorName'];
  static values = { blank: String };

  connect() {
    this.toggleSubmitButton();
  }

  toggleSubmitButton() {
    const { value } = this.selectTarget;

    this.submitButtonTarget.disabled = value === '';
    this.newAdvisorNameTarget.textContent =
      value === '' ? this.blankValue : this.selectTarget.selectedOptions[0].textContent;
  }
}
